import styled from 'styled-components';
import { v2Breakpoints } from '../../formInputsV2/styles/tokens';

// Body of the driver/owner card — the header itself now comes from the
// shared SurfaceCard/SurfaceCardHeader/SurfaceCardHeading primitives
// (see OffcanvasForm.jsx) so every "card with a green title bar" in the app
// stays visually identical and updates from one place.
export const FormInputsBody = styled.div`
  margin: auto;
  padding: 10px 0 6px;
  width: 100%;
  max-width: 550px;

  @media (max-width: ${v2Breakpoints.tablet}) {
    padding: 8px 0 4px;
  }
`;
